import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { Model } from 'icreate/common/models/device';
import { fromEvent, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-device-model-dropdown',
    templateUrl: './device-model-dropdown.component.html',
    styleUrl: './device-model-dropdown.component.css',
    standalone: false,
})
export class DeviceModelDropdownComponent implements OnInit, OnDestroy {
    @Input() modelOptions: Model[];
    @Input() unitModel: Model;
    @Output() onModelSelected: EventEmitter<Model> = new EventEmitter();
    @ViewChild('container') container: ElementRef;
    @ViewChild('dropdownElement') dropdownElement: ElementRef;

    displayList: boolean = false;
    optionsTop: string;
    optionsLeft: string;
    optionsWidth: string;

    private destroy$: Subject<void> = new Subject();

    @HostListener('document:click', ['$event'])
    clickOut(event: MouseEvent) {
        if (this.displayList && !this.container?.nativeElement.contains(event.target)) {
            this.displayList = false;
        }
    }

    ngOnInit(): void {
        const scrollContainer = document.querySelector('.system-setting-scroll-parent');
        if (scrollContainer) {
            fromEvent(scrollContainer, 'scroll')
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    this.displayList = false;
                });
        }

        const scrollContainer2 = document.querySelector('.scroll-content');
        if (scrollContainer2) {
            fromEvent(scrollContainer2, 'scroll')
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    this.displayList = false;
                });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    selectModel(model: Model) {
        this.unitModel = model;
        this.onModelSelected.emit(model);
        this.displayList = false;
    }

    openSelect() {
        this.displayList = !this.displayList;
        if (this.displayList) {
            this.updatePosition();
        }
    }

    private updatePosition() {
        if (!this.container) return;
        const containerPosition = this.container.nativeElement.getBoundingClientRect();
        const scrollTop = window.scrollY;
        const scrollLeft = window.scrollX;

        this.optionsTop = containerPosition.bottom + scrollTop + 2 + 'px';
        this.optionsLeft = containerPosition.left + scrollLeft + 'px';
        this.optionsWidth = containerPosition.width + 'px';
    }
}
